<div class="attachments-section">
  <h2 class="section-title">{{ titleKey() | translate }}</h2>
  <div class="attachments-grid">
    @for (item of items(); track item.id || item.guid) {
      <app-attachment-list-item
        [item]="item"
        [canDelete]="canDelete()"
        [canDownload]="canDownload()"
        (expandItem)="expandItem.emit($event)"
        (downloadItem)="downloadItem.emit($event)"
        (deleteItem)="deleteItem.emit($event)" />
    }
  </div>
</div>
